module.exports = __webpack_public_path__ + "static/media/ricardo-perez-pin.e33d1bcd.svg";